import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getGolferOrderActionTypes} from "../services/GolferService";

export function useGolferOrderActionTypes(enabled = true, resetKey, callback = () => {}) {
    const [golferOrderActionTypes, setGolferOrderActionTypes] = useState([]);

    const {data} = useQuery({
        queryKey: ["golferOrderActionTypes", resetKey],
        queryFn: () => getGolferOrderActionTypes(),
        retry: false,
        enabled: enabled,
        staleTime: 1000 * 60 * 5,
    });
    useEffect(() => {
        if (data) {
            const newGolferOrderActionTypes = data.map((item) => ({id: item.name, name: item.name}));
            setGolferOrderActionTypes(newGolferOrderActionTypes);
            callback(newGolferOrderActionTypes);
        }
    }, [data]);

    return golferOrderActionTypes;
}
